module.exports = __webpack_public_path__ + "img/86.9.TU.4d773826.png";